import { PortalDialogProps } from "@app/services/modal.service";
import Modal from "../modal/modal.component";
import Button from "../button";
import { useEffect, useState } from "react";
import { getMobileOperatingSystem } from "@app/utils/util";
import { AppLink, MobileOS } from "@app/constants";

function InstallAppModal({ portalDialogRef }: PortalDialogProps) {
  const [mobileOS, setMobileOS] = useState("");
  const [appLink, setAppLink] = useState("");

  useEffect(() => {
    const os = getMobileOperatingSystem();

    if ([MobileOS.ANDROID, MobileOS.IOS].includes(os as any)) {
      setMobileOS(os);
    }

    if (os === MobileOS.ANDROID) {
      setAppLink(AppLink.ANDROID);
    }

    if (os === MobileOS.IOS) {
      setAppLink(AppLink.IOS);
    }
  }, []);

  const handleDownloadClick = () => {
    if (appLink) {
      window.open(appLink);
    }
  };

  return (
    <Modal onCancel={portalDialogRef.close}>
      <div className="w-[350px] py-7 px-6">
        <div className="mt-5">
          <div className="text-lg font-bold">
            Bạn đang sử dụng thiết bị {mobileOS}
          </div>
          <div className="text-lg font-bold mt-3">
            Hãy tải ứng dụng trên điện thoại để có thể trải nghiệm nghe sách nói
            tốt nhất
          </div>
        </div>
        <div className="flex gap-3">
          <Button
            containerClassName="mt-5 mx-auto"
            label="Tải app"
            width="fit-content"
            size="l"
            className="font-bold px-5"
            onClick={handleDownloadClick}
          />
          <Button
            containerClassName="mt-5 mx-auto"
            label="Tiếp tục với web"
            width="fit-content"
            size="l"
            className="font-bold px-5"
            onClick={portalDialogRef.close}
          />
        </div>
      </div>
    </Modal>
  );
}

export default InstallAppModal;
